<template>
  <div>
    <page-header
      :title="$t('system.system_service')"
      :tabs="cloudEnvOptions"
      :current-tab.sync="cloudEnv" />
    <page-body>
      <list :id="listId" :cloud-env="cloudEnv" />
    </page-body>
  </div>
</template>

<script>
import List from './components/List'

export default {
  name: 'ServiceIndex',
  components: {
    List,
  },
  data () {
    return {
      listId: 'ServiceList',
      cloudEnv: 'service',
      cloudEnvOptions: [
        { label: this.$t('system.controller_service'), key: 'service' },
        { label: this.$t('system.compute_service'), key: 'host' },
        { label: this.$t('system.agent_service'), key: 'baremetalagent' },
      ],
    }
  },
}
</script>
